import { useQuery } from 'react-query';

import { SellerConfiguration } from '@savgroup-front-common/types';
import { CommonSellerService } from '../api';
import { useToasts } from '../molecules/NotificationsProvider';

interface UseGetSellerConfigurationArgs {
  sellerId?: string;
}

interface UseGetSellerConfigurationReturnValues {
  sellerConfiguration?: SellerConfiguration;
  isLoading: boolean;
}

export const GetSellerConfigurationQuery = 'getSellerConfigurationQuery';

const useGetSellerConfiguration = ({
  sellerId,
}: UseGetSellerConfigurationArgs): UseGetSellerConfigurationReturnValues => {
  const { pushErrors } = useToasts();

  const { data: sellerConfiguration, isLoading } = useQuery(
    [GetSellerConfigurationQuery, { sellerId }],
    async () => {
      if (!sellerId) {
        return undefined;
      }

      const response = await CommonSellerService.getSellerConfigurationQuery({
        sellerId,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      return response.value;
    },
    {
      staleTime: Infinity,
      suspense: true,
    },
  );

  return { sellerConfiguration, isLoading };
};

export default useGetSellerConfiguration;
